// 한국어 문구. 키를 추가할 때는 각 언어 파일의 구조를 동일하게 유지하세요.
import type { Messages } from "./zh-CN";

const koKR: Messages = {
  common: {
    language: "언어",
    confirm: "확인",
    cancel: "취소",
    save: "저장",
    delete: "삭제",
    edit: "편집",
    search: "검색",
    loading: "불러오는 중…",
    empty: "데이터가 없습니다",
  },
  nav: {
    workbench: "워크벤치",
    platform: "플랫폼",
    myProjects: "내 프로젝트",
    overview: "개요",
    summarySettings: "요약 설정",
    growth: "그로스",
    projectSettings: "프로젝트 설정",
    account: "계정 설정",
    aiCapability: "AI 기능",
    dataGrowth: "데이터 및 성장",
    dataAccount: "데이터 및 결제",
    accessHelp: "연동 및 도움말",
    admin: "관리 콘솔",
    home: "홈",
    knowledge: "지식 베이스",
    agents: "에이전트",
    aiChat: "채팅 및 위젯",
    podcast: "AI 팟캐스트",
    mcp: "MCP 서비스",
    models: "모델 센터",
    analytics: "사이트 분석",
    agentAudit: "에이전트 감사",
    chatHistory: "채팅 기록",
    tokenUsage: "사용 기록",
    myOrders: "내 주문",
    invitation: "초대",
    codeGenerator: "사이트 연동",
    api: "채팅 API",
    docs: "사용 문서",
    about: "회사 소개",
  },
  admin: {
    userManagement: "사용자 관리",
    productManagement: "상품 관리",
    orderManagement: "주문 관리",
    redeemCode: "교환 코드 생성",
    dataControl: "데이터 관리",
    modelGateway: "모델 게이트웨이",
    systemSettings: "시스템 설정",
  },
  user: {
    settings: "사용자 설정",
    orders: "내 주문",
    usage: "사용 기록",
    logout: "로그아웃",
  },
  mcpServer: {
    needVip: "MCP 클라이언트 기능을 사용하려면 연간 회원 가입이 필요합니다",
    vipDesc: "연간 회원으로 업그레이드하면 MCP 클라이언트 기능으로 타사 도구 서비스에 연결할 수 있습니다",
    backHome: "홈으로 돌아가 회원 가입",
    serverTab: "MCP 서버",
    clientTab: "MCP 클라이언트",
  },
  payment: {
    invalidRedeem: "유효한 교환 코드를 입력하세요",
    redeemSuccess: "교환에 성공했습니다",
  },
  modelCenter: {
    type: { chat: "채팅", embedding: "벡터", rerank: "재정렬", image: "이미지" },
    filterAll: "전체",
    filterTools: "도구 호출",
    filterImage: "이미지",
    empty: "조건에 맞는 모델이 없습니다",
    modelN: "모델 {{id}}",
    default: "기본",
    basicChat: "기본 채팅",
    context: "컨텍스트",
    maxOutput: "최대 출력",
    pendingPrice: "가격 미정",
    input: "입력",
    output: "출력",
    fetchFailed: "모델 목록을 가져오지 못했습니다",
    fetchFailedRetry: "모델 목록을 가져오지 못했습니다. 잠시 후 다시 시도하세요",
  },
  oauth: {
    noCode: "인증 실패: 인증 코드를 받지 못했습니다",
    loginSuccess: "{{provider}} 로그인에 성공했습니다!",
    bindSuccess: "{{provider}} 계정 연동에 성공했습니다",
    opFailed: "{{provider}} 작업에 실패했습니다",
    opFailedRetry: "{{provider}} 작업에 실패했습니다. 다시 시도하세요",
    processing: "{{provider}} 로그인을 처리하는 중...",
  },
  auth: {
    email: "이메일",
    password: "비밀번호",
    confirmPassword: "비밀번호 확인",
    newPassword: "새 비밀번호",
    confirmNewPassword: "새 비밀번호 확인",
    verifyCode: "인증 코드",
    emailVerifyCode: "이메일 인증 코드",
    imageCaptcha: "이미지 인증 코드",
    passkeyLogin: "패스키로 로그인",
    passwordLogin: "비밀번호로 로그인",
    usePassword: "비밀번호로 로그인",
    usePasskey: "패스키로 로그인",
    register: "회원가입",
    registerTitle: "계정 등록",
    resetTitle: "비밀번호 재설정",
    resetPassword: "비밀번호 재설정",
    noAccount: "계정이 없으신가요? 지금 가입",
    haveAccount: "이미 계정이 있으신가요? 지금 로그인",
    forgotPassword: "비밀번호를 잊으셨나요?",
    backToLogin: "로그인으로 돌아가기",
    sendCode: "인증 코드 보내기",
    getCaptcha: "인증 코드 받기",
    retryAfter: "{{n}}초 후 다시 시도",
    otherLogin: "다른 로그인 방법",
    githubLogin: "GitHub 로그인",
    qqLogin: "QQ 로그인",
    legacyTip: "구버전 요약 AI 및 PostChat 시스템 사용자는 가입 없이 QQ로 바로 로그인하세요",
    autoReturnTip: "로그인 후 이전에 보던 페이지로 자동으로 돌아갑니다",
    autoLoggingIn: "로그인 중입니다. 잠시만 기다려 주세요...",
    captchaAlt: "인증 코드",
    operatedBy: "베이징 훙후이 테크 스토어(개인 사업자) 운영",
    userAgreement: "이용약관",
    privacy: "개인정보 처리방침",
    rules: {
      requiredEmail: "이메일을 입력하세요",
      invalidEmail: "유효한 이메일 주소를 입력하세요",
      requiredPassword: "비밀번호를 입력하세요",
      requiredVerifyCode: "인증 코드를 입력하세요",
      requiredEmailCode: "이메일 인증 코드를 입력하세요",
      requiredCaptcha: "이미지 인증 코드를 입력하세요",
      requiredConfirm: "비밀번호를 확인하세요",
      requiredNewPassword: "새 비밀번호를 입력하세요",
      requiredConfirmNew: "새 비밀번호를 확인하세요",
      passwordMin8: "비밀번호는 최소 8자 이상이어야 합니다",
      passwordMin6: "비밀번호는 최소 6자 이상이어야 합니다",
      passwordPattern: "비밀번호에는 영문자와 숫자가 포함되어야 합니다",
      passwordMismatch: "입력한 비밀번호가 일치하지 않습니다",
    },
    msg: {
      enterEmailFirst: "먼저 이메일을 입력하세요",
      passkeyFailed: "패스키 로그인에 실패했습니다",
      passkeyVerifyFailed: "패스키 인증에 실패했습니다",
      passkeyTryPassword: "패스키 로그인에 실패했습니다. 비밀번호 로그인을 시도하세요",
      opCancelled: "작업이 취소되었거나 권한이 없습니다",
      securityError: "보안 오류입니다. 교차 출처 문제일 수 있습니다",
      opAborted: "작업이 중단되었습니다",
      loginSuccessConsole: "로그인에 성공했습니다. 콘솔로 이동 중입니다",
      loginSuccessBack: "로그인에 성공했습니다. 이전 페이지로 돌아가는 중입니다",
      linkInvalid: "로그인 링크가 유효하지 않습니다. 다시 받으세요",
      linkExpired: "로그인 링크가 만료되었습니다. 다시 받으세요",
      loginFailedManual: "로그인에 실패했습니다. 수동 로그인을 시도하세요",
      tooManyAttempts: "로그인 시도 횟수가 너무 많습니다. 잠시 후 다시 시도하세요",
      wrongCredentials: "사용자 이름 또는 비밀번호가 올바르지 않습니다",
      enterValidEmailPwd: "올바른 이메일과 비밀번호를 입력하세요",
      loginFailedRetry: "로그인에 실패했습니다. 다시 시도하세요",
      loginFailed: "로그인에 실패했습니다",
      systemError: "시스템 오류입니다. 잠시 후 다시 시도하세요",
      registerSuccess: "회원가입에 성공했습니다!",
      registerFailed: "회원가입에 실패했습니다",
      codeSent: "인증 코드를 보냈습니다",
      sendCodeFailed: "인증 코드 전송에 실패했습니다",
      captchaFailed: "인증 코드를 가져오지 못했습니다",
      resetSuccess: "비밀번호 재설정에 성공했습니다!",
      resetFailed: "비밀번호 재설정에 실패했습니다",
      resetFailedRetry: "비밀번호 재설정에 실패했습니다. 다시 시도하세요",
    },
  },
  siteWorkspace: {
    back: "모든 사이트", aria: "사이트 기능", overview: "개요", copilot: "Copilot", playbook: "플레이북", knowledge: "지식", abilities: "기능", test: "테스트", appearance: "외관", analytics: "분석", settings: "설정", publish: "게시 센터",
    common: { retry: "다시 시도", draft: "초안", published: "게시됨", healthy: "정상", degraded: "성능 저하", confirmRequired: "실행 전 확인", noData: "데이터 없음" },
    risk: { read: "읽기 전용", draft: "초안", write: "쓰기", sensitive: "민감", financial: "금융", irreversible: "되돌릴 수 없음" },
    release: { ownerCanary: "관리자만", percent1: "방문자 1%", percent10: "방문자 10%", percent50: "방문자 50%", all: "모든 방문자" },
  },
};

export default koKR;
